export const VALID_TAGS = [
    "2-SAT",
    "Binary Search",
    "Bitmasks",
    "Brute Force",
    "Chinese Remainder Theorem",
    "Combinatorics",
    "Constructive Algorithms",
    "Data Structures",
    "DFS",
    "Divide and Conquer",
    "DP",
    "DSU",
    "Expression Parsing",
    "FFT",
    "Flow",
    "Games",
    "Geometry",
    "Graph Matching",
    "Graphs",
    "Greedy",
    "Hashing",
    "Implementation",
    "Interactive",
    "Math",
    "Matrices",
    "Meet-in-the-Middle",
    "Number Theory",
    "Probabilities",
    "Schedules",
    "Shortest Path",
    "Sorting", 
    "String Suffix Structures",
    "Strings",
    "Ternary Search",
    "Trees",
    "Two Pointers",
    "Ad-hoc"
]